import type { ImageStyleUri } from '@/src/cms/domain/models/fields/file-field/image-style-uri';
import type { ImageField } from '@/src/cms/domain/models/fields/image-field';

export class ImageViewModel {
  src: string;

  alt: string;

  title: string;

  filename: string;

  constructor(data: { src: string; alt: string; title: string; filename: string }) {
    this.src = data.src;
    this.alt = data.alt;
    this.title = data.title;
    this.filename = data.filename;
  }

  static presenter(
    entity: ImageField,
    imageStyle: keyof ImageStyleUri = 'background'
  ): ImageViewModel {
    return new ImageViewModel({
      filename: entity.fieldMediaImage?.filename || '',
      alt: entity.fieldMediaImage?.meta?.alt || '',
      title: entity.fieldMediaImage?.meta?.title || '',
      src: entity.fieldMediaImage?.imageStyleUri?.[imageStyle] || ''
    });
  }
}
